import { Action } from '@ngrx/store';
import { UsersCRUDInterface } from '../../../shared/component/filter/filter.class';
import { FilterConditionInterface } from '../filter.model';

export enum FilterUserActionTypes {
  StartLoadFilterUsers = '[Filter User] Load Filter Users',
  FilterUsersLoaded = '[Filter User] Filter Users Loaded',
  ResetUserStore = '[Filter User] Reset store data for user filter',
}

export class StartLoadFilterUsers implements Action {
  readonly type = FilterUserActionTypes.StartLoadFilterUsers;
  constructor(public page: number, public limit: number, public filter: FilterConditionInterface[]) {}
}
export class FilterUsersLoaded implements Action {
  readonly type = FilterUserActionTypes.FilterUsersLoaded;
  constructor(public data: UsersCRUDInterface[]) {}
}
export class ResetUserStore implements Action {
  readonly type = FilterUserActionTypes.ResetUserStore;
}

export type FilterUserActions = StartLoadFilterUsers | FilterUsersLoaded | ResetUserStore;
